import React from "react";
import LoadingIcon from "../atoms/LoadingIcon";

interface IProps {
  isLoading: boolean;
}

// reference: https://medium.com/@jrwebdev/react-higher-order-component-patterns-in-typescript-42278f7590fb#file-loading-hoc-sfc-tsx

const WithLoading = <P extends object>(
  Component: React.ComponentType<P>
): React.FC<P & IProps> => ({ isLoading, ...props }: IProps) =>
  isLoading ? <LoadingIcon /> : <Component {...(props as P)} />;

export default WithLoading;
